type SettingsIconProps = {
  color?: string;
};

export default function SettingsIcon({ color = '#047dba' }: SettingsIconProps) {
  return (
    <svg
      id="uuid-b41530dd-b837-4b79-a3fb-adec0c84322e"
      data-name="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 240 240">
      <rect style={{ fill: color }} x="110.06" y="110.07" width="94.89" height="20" />
      <rect style={{ fill: color }} x="35.17" y="55.01" width="104.89" height="20" />
      <path
        style={{ fill: color }}
        d="M174.81,50.11v-10.4h-20v50.31h20v-10.11c0-2.71,2.19-4.9,4.9-4.9h25.23v-20h-25.23c-2.71,0-4.9-2.19-4.9-4.9Z"
      />
      <rect style={{ fill: color }} x="35.06" y="165.14" width="60" height="20" />
      <path
        style={{ fill: color }}
        d="M70.16,110.07h-34.98v20h34.98c2.71,0,4.9,2.19,4.9,4.9v10.25h20v-50.31h-20v10.25c0,2.71-2.19,4.9-4.9,4.9Z"
      />
      <path
        style={{ fill: color }}
        d="M130.06,149.98h-20v50.31h20v-10.25c0-2.71,2.19-4.9,4.9-4.9h69.98v-20h-69.98c-2.71,0-4.9-2.19-4.9-4.9v-10.26Z"
      />
    </svg>
  );
}

SettingsIcon.defaultProps = {
  color: '#047dba',
};
